<template>
  <div id="modal_onlineUsers" class="uk-modal" uk-modal="">
    <div class="uk-modal-dialog">
      <button class="uk-modal-close-default" type="button" uk-close></button>
      <div class="uk-modal-header online-users-header">
        <div class="header-content">
          <div class="header-icon">
            <i class="uil-users-alt"></i>
          </div>
          <div class="header-text">
            <h2 class="uk-modal-title">{{ $t("general.online_person") }}</h2>
            <p class="user-count">
              {{ onlineUsers.length }} {{ $t("home.Person_Online") }}
            </p>
          </div>
        </div>
      </div>
      <div class="uk-modal-body online-users-body">
        <div v-if="onlineUsers.length === 0" class="empty-state">
          <div class="empty-icon">
            <i class="uil-user-times"></i>
          </div>
          <p>Şu anda kimse çevrimiçi değil</p>
        </div>
        <ul v-else class="online-users-list">
          <li v-for="onlineUser in onlineUsers" :key="onlineUser.user" class="user-item">
            <div class="user-avatar">
              <div class="avatar-circle">
                {{ getInitials(onlineUser) }}
              </div>
              <div class="online-indicator"></div>
            </div>
            <span class="user-name">{{ getSurnameMasked(onlineUser) }}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OnlineUsersModal",
  props: {
    onlineUsers: {
      type: Array,
      default: () => [],
    },
    userInfo: {
      type: Object,
      default: null,
    },
    company: {
      type: Object,
      default: null,
    },
  },
  methods: {
    show() {
      this.$nextTick(() => {
        UIkit.modal("#modal_onlineUsers").show();
      });
    },
    getInitials(user) {
      if (!user || typeof user !== "object") return "?";
      const name = user.name?.trim();
      const surname = user.surname?.trim();
      const firstInitial = name ? name[0].toUpperCase() : "";
      const secondInitial = surname ? surname[0].toUpperCase() : "";
      const initials = firstInitial + secondInitial;

      return initials || "?";
    },
    getSurnameMasked(user) {
      if (this.userInfo?.id === user.user) {
        return `${user.name} ${user.surname}`;
      }

      const isAdminOrSuperAdmin = this.$roleCount() > 1 || this.$isSuperAdmin;
      if (!isAdminOrSuperAdmin && this.company?.surname_view_restrict === 1) {
        const firstLetter = user.surname?.[0] || "";
        return `${user.name} ${firstLetter}****`;
      }

      return `${user.name} ${user.surname}`;
    },
  },
};
</script>

<style lang="scss" src="./online-users-modal.scss"></style>
